var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "p-1" },
    [
      _c(
        "header",
        {
          staticClass: "pb-1 d-flex justify-content-between align-items-start",
        },
        [
          _c(
            "div",
            { staticClass: "d-flex column align-items-center" },
            [
              _c(
                "span",
                { staticClass: "brand-logo mr-1" },
                [
                  _c("b-img", {
                    staticClass: "rounded",
                    attrs: {
                      id: "logo",
                      src: _vm.style ? _vm.style.reducedHeaderImage : "",
                      alt: "logo",
                      fluid: "",
                    },
                  }),
                ],
                1
              ),
              _c("h1", { staticClass: "text-dark h1 mb-0" }, [
                _vm._v(" " + _vm._s(_vm.$t("Delivery")) + " "),
              ]),
              _c("b-avatar", {
                staticClass: "badge-minimal ml-1",
                attrs: {
                  size: "40",
                  icon: "chat",
                  variant: "light-primary",
                  badge: "",
                  "badge-variant": _vm.chatWebSocketConnected
                    ? "success"
                    : "danger",
                  title: _vm.$t("Indica o status da conexão com os chats"),
                },
              }),
              _c("br"),
            ],
            1
          ),
          _vm.filter.storeId
            ? _c(
                "div",
                [
                  _c("b-avatar", {
                    staticClass: "badge-minimal ml-1",
                    attrs: {
                      size: "40",
                      icon: "truck",
                      variant: "light-primary",
                      badge: "",
                      "badge-variant": _vm.deliveryWebSocketConnected
                        ? "success"
                        : "danger",
                      title: _vm.$t(
                        "Indica o status da conexão com a atualização dos pedidos de delivery"
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "link-primary",
                        title: _vm.$t("Atualizar lista de pedidos"),
                      },
                      on: { click: _vm.getData },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "arrow-clockwise", "font-scale": "1" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "link-primary",
                        title: _vm.$t("Testar som"),
                      },
                      on: { click: _vm.testSound },
                    },
                    [
                      _c("b-icon", {
                        attrs: { icon: "volume-up", "font-scale": "1" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticStyle: { "min-width": "300px" } },
            [
              _c("e-store-combo", {
                attrs: {
                  disabled: !_vm.ready,
                  required: false,
                  clearable: true,
                  "only-active-options": true,
                  placeholder: _vm.ready
                    ? _vm.$t("Selecione")
                    : _vm.$t("Aguarde..."),
                },
                on: { input: _vm.onStoreChanged },
                model: {
                  value: _vm.filter.storeId,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "storeId", $$v)
                  },
                  expression: "filter.storeId",
                },
              }),
            ],
            1
          ),
        ]
      ),
      !_vm.filter.storeId
        ? _c("div", { staticClass: "text-center" }, [
            _c("span", { staticClass: "h2" }, [
              _vm._v(" " + _vm._s(_vm.needSearchMessage)),
            ]),
          ])
        : _c(
            "div",
            [
              _vm.motoboyEnabled
                ? _c("motoboy-section", { attrs: { loading: _vm.fetching } })
                : _vm._e(),
              _c("e-color-subtitled", { attrs: { colors: _vm.legendColors } }),
              _c(
                "b-tabs",
                {
                  staticClass: "delivery-tabs",
                  model: {
                    value: _vm.activeTabIndex,
                    callback: function ($$v) {
                      _vm.activeTabIndex = $$v
                    },
                    expression: "activeTabIndex",
                  },
                },
                [
                  _c(
                    "b-tab",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.setActiveTab("delayed")
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Pedidos Anteriores")) + " "
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "ml-1",
                                  attrs: { variant: "danger" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.tabBadge("delayed")) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    _vm._l(_vm.statusSections, function (status) {
                      return _c("delivery-section", {
                        key: "delayed-" + status.key,
                        staticClass: "mt-3",
                        attrs: {
                          loading: _vm.fetching,
                          "title-text": status.label,
                          "delivery-list":
                            _vm.ordersByTabAndStatus.delayed[status.key],
                          "empty-message": _vm.lastFetch
                            ? status.emptyMessageDelayed
                            : _vm.needSearchMessage,
                          now: _vm.now,
                        },
                        on: { "show-chat": _vm.showChatSidebar },
                      })
                    }),
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.setActiveTab("today")
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Pedidos de Hoje")) + " "
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "ml-1",
                                  attrs: { variant: "primary" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.tabBadge("today")) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    _vm._l(_vm.statusSections, function (status) {
                      return _c("delivery-section", {
                        key: "today-" + status.key,
                        staticClass: "mt-3",
                        attrs: {
                          loading: _vm.fetching,
                          "title-text": status.label,
                          "delivery-list":
                            _vm.ordersByTabAndStatus.today[status.key],
                          "empty-message": _vm.lastFetch
                            ? status.emptyMessageToday
                            : _vm.needSearchMessage,
                          now: _vm.now,
                        },
                        on: { "show-chat": _vm.showChatSidebar },
                      })
                    }),
                    1
                  ),
                  _c(
                    "b-tab",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.setActiveTab("upcoming")
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _vm._v(
                                " " + _vm._s(_vm.$t("Próximos Pedidos")) + " "
                              ),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "ml-1",
                                  attrs: { variant: "primary" },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.tabBadge("upcoming")) + " "
                                  ),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    _vm._l(_vm.statusSections, function (status) {
                      return _c("delivery-section", {
                        key: "upcoming-" + status.key,
                        staticClass: "mt-3",
                        attrs: {
                          loading: _vm.fetching,
                          "title-text": status.label,
                          "delivery-list":
                            _vm.ordersByTabAndStatus.upcoming[status.key],
                          "empty-message": _vm.lastFetch
                            ? status.emptyMessageUpcoming
                            : _vm.needSearchMessage,
                          now: _vm.now,
                        },
                        on: { "show-chat": _vm.showChatSidebar },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c("chat-side-bar", { ref: "chatSidebar" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }